export const priceQuoteDataKeys: { [key: string]: string } = {
    franchiseWebLocationId: 'number',
    conceptId: 'number',
    serviceIdsAndQuantities: 'object',
  };
  